import React from "react";
import { AllContent, Content, Margin, report_def, ReportStructure } from "../core/pdf/types";
import { ElementState } from "./useElementContext";

export const DesignerContext = React.createContext({} as DesignerState);

export interface DesignerState {
	channel: string,

	def: report_def,

	title: string,
	structure: ReportStructure,

	// how track focus? 
	//focused: any,

	focus?: Content,

	bgPdfPages: any | undefined,

	nextID: () => number,
	createStyle: (baseFormats: any, overlayFormats?: any) => any,
	updateStyleMargin: (style: any, margin: Margin) => void,
	updateStyleFont: (style: any, formats: any) => void,

	broadcast: (msg: any) => void,
	broadcastToContent: (id: number, msg: any) => void,

	setFocus: (el?: Content) => void,

	getRef: (contentID: number) => Content | undefined,
	getContext: (contentID: number) => ElementState | undefined,

	createItem: (type: string, copyFrom?: Content) => Content | undefined,
	addItem: (item: Content, toArray: any[], relativeTo: Content, offset: number) => void,
	
	getContentArray: (item: Content) => AllContent[],

	addParagraph: (before?: boolean) => void,

	deleteItem: (item: Content) => void,

	refreshItem: (item: Content) => void,
	refreshRoot: () => void,

	save: (close: boolean) => void,
	delete: () => void,
	cancel: () => void,
	preview: () => void,
}

export function useDesigner() {
	return React.useContext(DesignerContext);
} 